export const initialState = () => ({
  filters: {
    //Collection
    academicYears: [],
    services: [],
    disciplines: [],
    statuses: [],
    centers: [],
    regions: [],
    municipalities: [],
    schools: [],
  },
  model: {
    //Selected Filters
    selectedYear: null,
    searchText: null,
    studentSie: null,
    selectedService: null,
    selectedDiscipline: null,
    selectedStatus: null,
    selectedCenter: null,
    selectedRegion: null,
    selectedMunicipality: null,
    selectedSchool: null,
    orderBy: null,
    startRowIndex: null,
    maxRowIndex: null,
  },
  results: [],
  paging: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
  },
  configPaginated: {
    pageSize: 10,
  },
});

export const state = initialState();
